import BalanceManagerJSON from "../../abis/perpetual-dex/BalanceManager.json";
import CLOBEngineDepositJSON from "../../abis/perpetual-dex/CLOBEngineDeposit.json";
import UnifiedVaultJSON from "../../abis/perpetual-dex/UnifiedVault.json";

export const UnifiedVaultABI = (UnifiedVaultJSON as any).abi || UnifiedVaultJSON;
export const CLOBEngineDepositABI = (CLOBEngineDepositJSON as any).abi || CLOBEngineDepositJSON;
export const BalanceManagerABI = (BalanceManagerJSON as any).abi || BalanceManagerJSON;

// BalanceManagerVault ABI — for reading balances (delegates to BalanceManager)
export const BALANCE_MANAGER_VAULT_ABI = [
  "function getTotalBalance(address user) external view returns (uint256)",
  "function getAvailableBalance(address user) external view returns (uint256)",
  "function getCrossMarginAllocated(address user) external view returns (uint256)",
  "function getIsolatedAllocated(address user) external view returns (uint256)",
  "function paused() external view returns (bool)",
];
